// React
import CountUp from 'react-countup';
import React, { useState, useEffect } from 'react';
import { APIClient } from '../../../../helpers/api_helper';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const DashboardWidgetsReckoning = ({ isShow, office }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const api = new APIClient();

  const WidgetsReckoning = () => {
    return (
      <Row>
        <Col xs={12} md={6} lg={6}>
          <Card className="card-animate bg-success">
            <CardBody>
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="fw-medium mb-0 text-white">A receber hoje</h5>
                  <h2 className="ff-secondary fw-semibold text-white">
                    <span className="counter-value">
                      R${' '}
                      <CountUp
                        start={0}
                        separator="."
                        end={data?.receiveToday}
                        decimals={2}
                        decimal=","
                        duration={1}
                      />
                    </span>
                  </h2>
                  <p className="mb-0 text-white-50 fw-semibold">
                    Restante do mês
                  </p>
                  <p className="mb-0 text-white">
                    <span className="counter-value">
                      R${' '}
                      <CountUp
                        start={0}
                        separator="."
                        end={data?.receiveMonth}
                        decimals={2}
                        decimal=","
                        duration={1}
                      />
                    </span>
                  </p>
                </div>
                <div>
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title rounded-circle fs-2 bg-soft-light">
                      <i className="ri-time-line text-white"></i>
                    </span>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xs={12} md={6} lg={6}>
          <Card className="card-animate bg-danger">
            <CardBody>
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="fw-medium mb-0 text-white">A pagar hoje</h5>
                  <h2 className="ff-secondary fw-semibold text-white">
                    <span className="counter-value">
                      R${' '}
                      <CountUp
                        start={0}
                        separator="."
                        end={data?.payToday}
                        decimals={2}
                        decimal=","
                        duration={1}
                      />
                    </span>
                  </h2>
                  <p className="mb-0 text-white-50 fw-semibold">
                    Restante do mês
                  </p>
                  <p className="mb-0 text-white">
                    <span className="counter-value">
                      R${' '}
                      <CountUp
                        start={0}
                        separator="."
                        end={data?.payMonth}
                        decimals={2}
                        decimal=","
                        duration={1}
                      />
                    </span>
                  </p>
                </div>
                <div>
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title rounded-circle fs-2 bg-soft-light">
                      <i className="ri-time-fill text-white"></i>
                    </span>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  };

  const getFinancesWidgets = async (office) => {
    await api
      .get(`/overview/financial-summary?office=${office}`)
      .then((res) => {
        setData(res);
        setLoading(false);
      });
  };

  useEffect(() => {
    getFinancesWidgets(office);
  }, [office]);

  return loading ? (
    <SkeletonTheme baseColor="#8B919F">
      <Row className="mb-4">
        <Col xs={12} md={6} lg={6}>
          <Skeleton height={120} />
        </Col>
        <Col xs={12} md={6} lg={6}>
          <Skeleton height={120} />
        </Col>
      </Row>
    </SkeletonTheme>
  ) : isShow ? (
    <WidgetsReckoning />
  ) : null;
};
